var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12526_94305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1582 6.1849C20.1582 3.65359 18.1062 1.60156 15.5749 1.60156C13.0435 1.60156 10.9915 3.65359 10.9915 6.1849C10.9915 8.7162 13.0435 10.7682 15.5749 10.7682C18.1062 10.7682 20.1582 8.7162 20.1582 6.1849ZM15.992 6.60157L15.9925 8.68783C15.9925 8.91795 15.806 9.10448 15.5758 9.10448C15.3457 9.10448 15.1591 8.91795 15.1591 8.68783L15.1587 6.60157H13.0712C12.8413 6.60157 12.655 6.41502 12.655 6.1849C12.655 5.95479 12.8413 5.76824 13.0712 5.76824H15.1586L15.1582 3.68429C15.1582 3.45417 15.3448 3.26762 15.5749 3.26762C15.805 3.26762 15.9915 3.45417 15.9915 3.68429L15.992 5.76824H18.072C18.302 5.76824 18.4883 5.95479 18.4883 6.1849C18.4883 6.41502 18.302 6.60157 18.072 6.60157H15.992ZM18.0749 13.0599V10.9914C18.534 10.7521 18.9546 10.4489 19.3249 10.0936V13.0599C19.3249 14.5556 18.1123 15.7682 16.6165 15.7682H11.8353L7.6571 18.8938C7.19641 19.2384 6.54362 19.1442 6.19904 18.6836C6.06434 18.5034 5.99154 18.2846 5.99154 18.0598L5.99088 15.7682H5.36654C3.87076 15.7682 2.6582 14.5556 2.6582 13.0599V5.97656C2.6582 4.48079 3.87076 3.26823 5.36654 3.26823H11.0097C10.7626 3.65424 10.563 4.07367 10.4195 4.51823H5.36654C4.56112 4.51823 3.9082 5.17115 3.9082 5.97656V13.0599C3.9082 13.8653 4.56112 14.5182 5.36654 14.5182H7.24053L7.24142 17.6437L11.4195 14.5182H16.6165C17.422 14.5182 18.0749 13.8653 18.0749 13.0599Z",
    fill: "#9E9E9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12526_94305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.991211 0.768555)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentAdd);
export default __webpack_public_path__ + "static/media/comment-add.56fd2e8f.svg";
export { ForwardRef as ReactComponent };